import React, { Fragment, useRef } from "react";
import { useHistory } from "react-router";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { getFormattedDate } from "../../../util/dateFormatting";

const TD = ({ children, style = {} }: any) => {
    return <td style={{ padding: "10px 0px", color: "#4a4a4a", ...style }}>{children}</td>;
};

const TH = ({ children, style = {} }: any) => {
    return <th style={{ padding: "10px 0px", color: "#4a4a4a", ...style }}>{children}</th>;
};

const RiskRanking = ({ color = "" }) => {
    return (
        <div className="flex-row padding-right-xl">
            {/* <div>
				<span style={{ fontSize: "24px", color }}>4</span>
				<span style={{ marginLeft: "10px", color }}>
					Moderate Risk (4 of 10)
				</span>{" "}
			</div> */}
            <span>
                <em className="las la-angle-right"></em>
            </span>
        </div>
    );
};

function SearchResultTable({ breachResults, page, searchKey }: any) {
    const history = useHistory();
    const tableRowRef = useRef(null);

    const handleBreachDetails = (item: any) => {
        history.push({
            pathname: `/breaches/breach-details`,
            state: { id: item.breach_ID, search: searchKey, backPage: "breach_search", orgName: item.organization, breachDate: item.date_Of_Breach },
        });
    };

    let res = breachResults.body.length ? breachResults.body.slice(page === 1 ? 0 : (page - 1) * 25, page * 25) : [];

    const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>, item: any) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleBreachDetails(item);
        }
    }

    return (
        <Fragment>
            <table style={{ width: "100%" }}>
                <thead style={{ borderBottom: "1px solid #242a42" }}>
                    <tr>
                        <TH style={{ fontWeight: "600", color: "#00313c", width: "6rem" }}>Date</TH>
                        <TH style={{ fontWeight: "600", color: "#00313c", padding: "0px 20px" }}>Organization</TH>
                        {/* <TD style={{ fontWeight: "600", color: "#00313c" }}>
							Breach Risk Ranking
						</TD> */}
                    </tr>
                </thead>
                <tbody style={{ borderBottom: "1px solid #242a42" }}>
                    {res.length
                        ? res.map((item: any, i: any) => {
                              return (
                                  <tr
                                      key={`${item.id}-${i}`}
                                      style={{ borderBottom: res.length - 1 !== i ? "1px solid #e8e8e8" : "", cursor: "pointer" }}
                                      onClick={() => handleBreachDetails(item)}
                                      tabIndex={0}
                                      role="link"
                                      ref={tableRowRef}
                                      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => handleKeyPress(e, item)}
                                  >
                                      <TD>{getFormattedDate(i18nService.get("Country"), item.date_Of_Breach)}</TD>
                                      <TD style={{ fontWeight: "600", padding: "0px 20px", verticalAlign: "middle" }}>{item.organization}</TD>
                                      <TD>
                                          <RiskRanking color="#e27000" />
                                      </TD>
                                  </tr>
                              );
                          })
                        : null}
                </tbody>
            </table>
        </Fragment>
    );
}

export default SearchResultTable;
